export default () => ({
  translatedCalibrationHomepageMessage: ''
})



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/state.js